import React, { createContext, useContext, useEffect } from 'react';

import { usePop } from '@randajan/jet-react/dom/modal';
import { page } from '@randajan/jet-react/base/page';
import { Contact } from './Contact';

const _hkey = "hash.contact";
const _val = "up";

export const contactContext = createContext();
export const contactLink = "#contact=up";

export const ContactProvider = ({children})=>{
    const pop = usePop({
        className:"ContactPop",
        children:<Contact/>,
        onUp:_=>{
            if (page.get(_hkey) !== _val) { page.set(_hkey, _val); }
        },
        onDown:_=>{
            if (page.get(_hkey) === _val) { page.remove(_hkey); }
        }
    });

    useEffect(_=>{
        const handle = _=>{
            const v = page.get(_hkey);
            if (v === _val) { return pop.up(); }
            if (pop.isUp()) { pop.down(); }
        }

        handle();
        return page.watch(_hkey, handle);
    }, [pop]);

    const value = {
        show:_=>{
            page.set(_hkey, _val);
            pop.up();
        },
        link:contactLink
    }

    return <contactContext.Provider children={children} value={value}/>;

}

export const useContact = ()=>useContext(contactContext);
